import { useAppContext } from '../context/AppContext';
import { resetPassword } from '../services';
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import darkLogo from '../assets/dark-logo.png';
import lightLogo from '../assets/light-logo.png';

export const ResetPasswordPage = ({ darkMode }) => {
  const { base_url, showStatus } = useAppContext();
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!resetToken) {
      showStatus('error', 'This reset link is missing a token. Please request a new one.');
      return;
    }
    if (!password || !confirmPassword) {
      showStatus('error', 'Please enter and confirm your new password.');
      return;
    }
    if (password !== confirmPassword) {
      showStatus('error', 'Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const data = await resetPassword(resetToken, password, confirmPassword, base_url);
      setSuccess(true);
      showStatus(
        'success',
        data.msg || 'Password reset successfully. You can now log in with your new password.',
      );
    } catch (error) {
      showStatus('error', error.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!resetToken) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <img
                src={darkMode ? darkLogo : lightLogo}
                alt=""
                width={48}
                height={48}
                decoding="async"
              />
            </div>
            <h1>Slipstream</h1>
            <p>Invalid reset link</p>
          </div>
          <div className="login-success">
            <p>
              This password reset link is missing a token. Request a new email to continue.
            </p>
            <Link to="/forgot-password" className="btn btn-primary login-submit">
              Request a new link
            </Link>
          </div>
          <p className="login-footer-link">
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img
              src={darkMode ? darkLogo : lightLogo}
              alt=""
              width={48}
              height={48}
              decoding="async"
            />
          </div>
          <h1>Slipstream</h1>
          <p>{success ? 'Password updated' : 'Choose a new password'}</p>
        </div>

        {success ? (
          <div className="login-success">
            <p>Your password has been reset. You can now sign in with your new password.</p>
            <Link to="/login" className="btn btn-primary login-submit">
              Sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label" htmlFor="reset-password">New password</label>
              <input
                id="reset-password"
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="new-password"
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="reset-confirm">Confirm password</label>
              <input
                id="reset-confirm"
                className="form-input"
                type="password"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary login-submit"
              disabled={loading}
            >
              {loading ? 'Updating…' : 'Reset password'}
            </button>
          </form>
        )}

        {!success && (
          <p className="login-footer-link">
            Link expired? <Link to="/forgot-password">Request a new one</Link>
          </p>
        )}
      </div>
    </div>
  );
};
